'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosMicOutline = function IoIosMicOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 2.5c3.4 0 6.2 3 6.2 6.6v12c0 3.6-2.8 6.6-6.2 6.6s-6.2-3-6.2-6.6v-12c0-3.6 2.8-6.6 6.2-6.6z m4.9 18.6v-12c0-2.9-2.2-5.3-4.9-5.3s-4.9 2.4-4.9 5.3v12c0 2.9 2.2 5.3 4.9 5.3s4.9-2.4 4.9-5.3z m3.8-6.1h1.3v6.3c0 5.2-4 9.5-9.1 9.9v4.9h5.4v1.4h-12.6v-1.4h5.7v-4.9c-5.3-0.4-9.4-4.7-9.4-9.9v-6.3h1.5v6.3c0 4.6 3.9 8.5 8.6 8.5s8.6-3.9 8.6-8.5v-6.3z' })
        )
    );
};

exports.default = IoIosMicOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-mic-outline.js
// module id = 2690
// module chunks = 168707334958949